import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react';

export const useOnChangeTextFilter = <T>(filterName: keyof T, setLocalFilters: Dispatch<SetStateAction<T>>) =>
    useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            const value = event.currentTarget.value;
            setLocalFilters((prevState) => ({ ...prevState, [filterName]: value === '' ? undefined : value }));
        },
        [filterName, setLocalFilters],
    );
